/*
 * @Author: 朱占伟
 * @LastEditors: 黄露
 * @description: 静态数据配置
 * @Date: 2021-09-07 17:01:43
 * @LastEditTime: 2022-01-18 15:55:51
 */

import {
  payOrderByPayPalId,
  payOrderByPayssion,
  payOrderByGloCash,
  payOrderByPayOp,
  payOrderByPayTest,
  payOrderByAllPay,
  getClientId,
  payOrderByPayPal,
  payOrderByPacypayDirect,
  payOrderByWanPay,
  payOrderByStripeAgent,
  payOrderByPassPay,
  payOrderByPayopBitcoin,
  payOrderByPayopBitcoinCash,
  payOrderByPayopLitecoin,
  payOrderByPayOpEthereum,
  payOrderByPayEpayEthereum,
  payOrderByCoinBase,
  payOrderByTripleA,
  payOrderByXanPay,
  payOrderByPayoneer,
  payOrderByCryptomus,
  payOrderByBinance
} from 'model/campaign';

import { getPayOrderByAirwallex4Sdk } from 'model/money';
import { Dialog } from 'vant';

const baseSign =
  'We do NOT store any of your payment credentials. All payments are processed via our payment provider';

//通用支付
const onPay = async (state) => {
  try {
    const res = await payOrderByPayssion(
      state.orderId,
      state.pmId,
      state.needJumpOrder
    );
    if (res) {
      state.newTab.location = res;
    }
    return res;
  } catch (error) {
    state.newTab.close();
  }
};

// AirwallEx

/**
 * onPay参数
 * state, ref, createOrderFn
 * 状态   dom引用   创建订单的方法
 * @returns
 */

const AirwallexPayList = function () {
  return [
    {
      type: 'AIRWALLEX',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-yd.svg',
      name: 'Airwallex',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId
          });
          if (res) {
            const { intentId, clientSecret } = res;
            console.log(ref);
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'card'
              },
              state.orderId
            );
          }
          // this.completeDialogShow = true
          // return res
        } catch (error) {
          console.error(error);
        }
      }
    },
    {
      type: 'AIRWALLEX_ALIPAY_CN',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-ali-cn.svg',
      name: 'Alipay CN',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId,
            payType: 'AIRWALLEX_ALIPAY_CN'
          });
          if (res) {
            const { intentId, clientSecret } = res;
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'ali_cn'
              },
              state.orderId
            );
          }
          // this.completeDialogShow = true
          // return res
        } catch (error) {
          console.error(error);
        }
      }
    },
    {
      type: 'AIRWALLEX_ALIPAY_HK',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-ali-hk.svg',
      name: 'Alipay HK',
      coinType: 'HKD',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId,
            payType: 'AIRWALLEX_ALIPAY_HK'
          });
          if (res) {
            const { intentId, clientSecret } = res;
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'ali_hk'
              },
              state.orderId
            );
          }
          // this.completeDialogShow = true
          // return res
        } catch (error) {
          console.error(error);
        }
      }
    },
    {
      type: 'AIRWALLEX_KAKAO_PAY',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-kakao.svg',
      name: 'Kakaopay',
      coinType: 'KRW',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId,
            payType: 'AIRWALLEX_KAKAO_PAY'
          });
          if (res) {
            const { intentId, clientSecret } = res;
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'kakao'
              },
              state.orderId
            );
          }
          // this.completeDialogShow = true
          // return res
        } catch (error) {
          console.error(error);
        }
      }
    },
    {
      type: 'AIRWALLEX_DOKU_WALLET',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-doku.svg',
      name: 'DOKU',
      coinType: 'IDR',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId,
            payType: 'AIRWALLEX_DOKU_WALLET'
          });
          if (res) {
            const { intentId, clientSecret } = res;
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'doku'
              },
              state.orderId
            );
          }
          // this.completeDialogShow = true
          // return res
        } catch (error) {
          console.error(error);
        }
      }
    },
    {
      type: 'AIRWALLEX_DANA',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-dana.svg',
      name: 'DANA',
      coinType: 'IDR',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId,
            payType: 'AIRWALLEX_DANA'
          });
          if (res) {
            const { intentId, clientSecret } = res;
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'dana'
              },
              state.orderId
            );
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    {
      type: 'AIRWALLEX_GOOGLE',
      onPayType: 'EmbedPage',
      img: 'images/payTypes/Airwallex/Airwallex-google-yd.svg',
      name: 'Google Pay',
      storeHint: `${baseSign} - Airwallex.`,
      async onPay(state, ref, createOrderFn) {
        try {
          await createOrderFn();
          const res = await getPayOrderByAirwallex4Sdk({
            orderId: state.orderId,
            payType: 'AIRWALLEX_GOOGLE'
          });
          if (res) {
            const { intentId, clientSecret } = res;
            ref.value.open(
              'AIRWALLEX',
              {
                intent_id: intentId,
                client_secret: clientSecret,
                type: 'google'
              },
              state.orderId
            );
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  ];
};

// CryptomusPayList

/**
 * onPay参数
 * state, ref, createOrderFn
 * 状态   dom引用   创建订单的方法
 * @returns
 */

const CryptomusPayList = function () {
  return [
    {
      type: 'CRYPTOMUS',
      // onPayType: 'ManualForm',
      img: 'images/payTypes/Cryptomus/Cryptomus.svg',
      name: 'Cryptomus',
      storeHint: `${baseSign} - Cryptomus.`,
      async onPay(state, form) {
        try {
          const res = await payOrderByCryptomus({
            orderId: state.orderId,
            isInsufficient: state.needJumpOrder,
            ...form
          });
          if (res) {
            state.newTab.location = res;
          } else {
            state.newTab.close();
          }
          return res;
        } catch (error) {
          state.newTab.close();
        }
      }
    }
  ]
};

/**
 * 获取paySession
 * @returns {object} session
 */
const getPaySession = () => {
  const session = sessionStorage.getItem('payFocus')
  return session ? JSON.parse(session) : null
}
/**
   * 写入pay session
   * @param {选择的支付方式类型} type
   * @return {void}
   */
const setSessionStorage = (type) => {
  const session = getPaySession() || {}
  sessionStorage.setItem('payFocus', JSON.stringify({
    ...session,
    [type]: true
  }))
}
/**
   * 检测pay session中的支付方式是否已经提示过
   * @param {选择的支付方式类型} type
   * @returns
   */
const detectSessionStorage = (type) => {
  const isShow = getPaySession()
  let result = false
  if (isShow && isShow[type]) {
    result = true
  }
  return result
}
/**
 * @description 支付方式的输入框聚焦提示
 */
const payInputFocus = {
  TRIPLE_A: {
    func() {
      const res = detectSessionStorage('TRIPLE_A')
      if (res) return
      else {
        Dialog.alert({
          title: '',
          message: 'Please assess if your app is suitable for this payment method to avoid payment failure, consult your personal manager for details.',
          confirmButtonText: 'OK'
        })
        setSessionStorage('TRIPLE_A')
      }
    }
  }
}


//支付方式相关
export const payTypeListInfo = [
  {
    type: 'PAY_PAL',
    img: 'images/payTypes/Paypal.svg',
    name: 'Paypal',
    hideBtn: true,
    async onSelect() {
      if (!document.getElementById('paypalJs')) {
        // 避免多次引入
        this.paypalLoading = true;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        const clientId = await getClientId();
        script.src = 'https://www.paypal.com/sdk/js?client-id=' + clientId;
        script.id = 'paypalJs';
        const p = new Promise(function (r) {
          script.onload = r;
        });
        document.body.appendChild(script);
        await p;
        this.paypalLoading = false;
      }
      const vm = this;
      // renderPaypal
      if (vm.state.paypalLoaded) {
        return;
      }
      vm.state.paypalLoaded = true;

      window.paypal
        .Buttons({
          style: {
            shape: 'rect',
            color: 'gold',
            layout: 'vertical'
          },
          onInit: function (data, actions) {
            actions.disable();
            document
              .querySelector('#paymentInput')
              .addEventListener('change', function () {
                if (
                  vm.rechargeForm.money &&
                  vm.rechargeForm.money >= vm.state.minAmount
                ) {
                  actions.enable();
                } else {
                  actions.disable();
                }
              });
          },
          // onClick is called when the button is clicked
          onClick: async function (data, actions) {
            if (window.$mine.state === 3) {
              //vm.$refs['noActiveTip'].dialogVisible = true
              return actions.reject();
            } else {
              return actions.resolve();
            }
          },
          createOrder: async function () {
            await vm.createOrderId();
            vm.state.completeDialogShow = true;
            const res = await payOrderByPayPalId(vm.state.orderId);
            return res;
          },
          onShippingChange() {},
          onCancel() {
            vm.state.completeDialogShow = false;
          },
          onApprove() {
            vm.state.completeDialogShow = false;
            // vm.$router.push({
            //   path: '/my/transactions',
            //   query: {
            //     orderType: 'Balance',
            //     orderId: vm.orderId
            //   }
            // })
          }
        })
        .render('#paypal-button-container');
    },
    inputHint: 'You can add money through PayPal account, VISA or Master Card.',
    storeHint: `${baseSign} - Paypal.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayPal({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          // window.open(res)
          state.newTab.location = res;
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PACY_PAY',
    img: 'images/payTypes/Pacypay.svg',
    name: 'Pacypay',
    inputHint: '',
    storeHint: `${baseSign} - Pacypay.`,
    async onPay(state) {
      try {
        const res = await payOrderByPacypayDirect({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });

        if (res) {
          state.newTab.location = res;
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PAYSSION_BITCOIN',
    img: 'images/payTypes/Bitcoin.svg',
    name: 'Payssion',
    pmId: 'bitcoin',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_ALIPAY',
    img: 'images/payTypes/Alipay.svg',
    name: 'Alipay',
    pmId: 'alipay_cn',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_NET_BANKING',
    img: 'images/payTypes/ebanking_in.svg',
    name: 'Net Banking',
    pmId: 'ebanking_in',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_UPI',
    img: 'images/payTypes/UPI.svg',
    name: 'UPI',
    pmId: 'upi_in',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_ATM',
    img: 'images/payTypes/ATM.svg',
    name: 'ATM',
    pmId: 'atm_id',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_ALFAMART',
    img: 'images/payTypes/ALFAMART.svg',
    name: 'Alfamart',
    pmId: 'alfamart_id',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_DOKU',
    img: 'images/payTypes/DOKU.svg',
    name: 'DOKU',
    pmId: 'doku_id',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_E_WALLET',
    img: 'images/payTypes/Wallet.svg',
    name: 'E-Wallet',
    pmId: 'wallet_in',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_DANA',
    img: 'images/payTypes/Dana.svg',
    name: 'Dana',
    pmId: 'dana_id',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_LINK_AJA',
    img: 'images/payTypes/LinkAja.svg',
    name: 'LinkAja',
    pmId: 'linkaja_id',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_OVO',
    img: 'images/payTypes/OVO.svg',
    name: 'OVO',
    pmId: 'ovo_id',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_KAKAOPAY_KR',
    img: 'images/payTypes/kakaopay_kr.svg',
    name: 'Kakaopay',
    pmId: 'kakaopay_kr',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_EBANKING_KR',
    img: 'images/payTypes/ebanking_kr.svg',
    name: 'E-banking',
    pmId: 'ebanking_kr',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_CREDIT_CARD_KR',
    img: 'images/payTypes/creditcard_kr.svg',
    name: 'Credit Card',
    pmId: 'creditcard_kr',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'PAYSSION_WEBMONEY',
    img: 'images/payTypes/Webmoney.svg',
    name: 'Webmoney',
    pmId: 'webmoney',
    inputHint: '',
    storeHint: `${baseSign} - Payssion.`,
    onPay
  },
  {
    type: 'WAN_PAY',
    img: 'images/payTypes/Wanpay.svg',
    name: 'Credit Card',
    inputHint: '',
    storeHint: `${baseSign} - wanpay.`,
    async onPay(state) {
      try {
        const res = await payOrderByWanPay({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          // window.open(res)
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'STRIPE_AGENT',
    img: 'images/payTypes/Stripe.svg',
    name: 'Bank Card',
    inputHint: '',
    storeHint: `${baseSign} - Stripe.`,
    async onPay(state) {
      try {
        const res = await payOrderByStripeAgent({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });

        if (res) {
          // window.open(res)
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    // TODO stripe 接入待测试,在stripe加载好之前应该Loading
    type: 'STRIPE',
    img: 'images/payTypes/VISA.svg',
    name: 'Bank Card',
    onSelect() {
      // TODO加载好之前应该loading
      if (!document.getElementById('stripeJs')) {
        // 避免多次引入
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://js.stripe.com/v3/';
        script.id = 'stripeJs';
        document.body.appendChild(script);
      }
    },
    async onPay(state) {
      try {
        const res = await payOrderByStripeAgent({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });

        if (res) {
          // window.open(res)
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'BANK',
    img: 'images/payTypes/money-wire.svg',
    name: 'Bank Card'
  },
  {
    type: 'PASS_PAY',
    img: 'images/payTypes/Passpay.svg',
    name: 'Credit Card',
    inputHint: '',
    storeHint: `${baseSign} - PassPay.`,
    async onPay(state) {
      try {
        const res = await payOrderByPassPay({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'ALL_PAY',
    img: 'images/payTypes/UnionPay.svg',
    name: 'Union Pay',
    inputHint: '',
    storeHint: `${baseSign} - GoAllPay.`,
    async onPay(state) {
      try {
        const res = await payOrderByAllPay({
          payType: 'UP',
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });

        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'GLOCASH',
    img: 'images/payTypes/glocash.svg',
    name: 'Credit Card',
    inputHint: '',
    storeHint: `${baseSign} - Glocash.`,
    async onPay(state) {
      try {
        const res = await payOrderByGloCash({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });

        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PAYOP',
    img: 'images/payTypes/payop.svg',
    name: 'PayOp',
    inputHint: '',
    storeHint: `${baseSign} - PayOp.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayOp({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'TEST',
    img: 'images/payTypes/payop.svg',
    name: 'Test',
    inputHint: '',
    storeHint: 'Use Just For Test',
    async onPay(state) {
      try {
        const res = await payOrderByPayTest({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
          state.newTab.close();
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  //   {
  //     type: 'AIRWALLEX_GOOGLE',
  //     img: 'images/payTypes/Airwallex-google-yd.svg',
  //     name: 'Google Pay',
  //     inputHint: '',
  //     storeHint:`${baseSign} - Airwallex.`,
  //     async onPay(state) {
  //       try {
  //         const res = await payOrderByPayAirwallex({
  //           orderId: state.orderId,
  //           isInsufficient: state.needJumpOrder
  //         })
  //         if (res) {
  //           state.newTab.location = res
  //         } else {
  //           state.newTab.close()
  //         }
  //         return res
  //       } catch (error) {
  //         state.newTab.close()
  //       }
  //     }
  //   },
  {
    type: 'PAYOP_BITCOIN',
    img: 'images/payTypes/Payop-Bitcoin.svg',
    name: 'Payop-Bitcoin',
    inputHint: '',
    storeHint: `${baseSign} - PayOp.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayopBitcoin({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PAYOP_BITCOINCASH',
    img: 'images/payTypes/PayOp-Cash.svg',
    name: 'PayOp-Bitcoin Cash',
    inputHint: '',
    storeHint: `${baseSign} - PayOp.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayopBitcoinCash({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PAYOP_LITECOIN',
    img: 'images/payTypes/PayOp-Litecoin.svg',
    name: 'PayOp-Litecoin',
    inputHint: '',
    storeHint: `${baseSign} - PayOp.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayopLitecoin({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PAYOP_ETHEREUM',
    img: 'images/payTypes/PayOp-Ethereum.svg',
    name: 'PayOp-Ethereum',
    inputHint: '',
    storeHint: `${baseSign} - PayOp.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayOpEthereum({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'EPAY_USDT',
    img: 'images/payTypes/epay.svg',
    name: 'EPAY_USDT',
    inputHint: '',
    storeHint: `${baseSign} -  Epay.`,
    async onPay(state) {
      try {
        const res = await payOrderByPayEpayEthereum({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = '/wap/checkstand?orderId=' + state.orderId;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'COIN_BASE',
    img: 'images/payTypes/coinBase-yd.svg',
    name: 'Coinbase',
    inputHint: '',
    storeHint: `${baseSign} -  Coinbase.`,
    async onPay(state) {
      try {
        const res = await payOrderByCoinBase({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'PAYONEER',
    // onPayType: 'ManualForm',
    img: 'images/payTypes/Payoneer-yd.svg',
    name: 'Payoneer',
    storeHint: `${baseSign} - Payoneer.`,
    async onPay(state, form) {
      try {
        const res = await payOrderByPayoneer({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder,
          ...form
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'TRIPLE_A',
    img: 'images/payTypes/Triple_A.svg',
    name: 'Triple_A',
    storeHint: `${baseSign} - TripleA.`,
    focusEvent() {
      payInputFocus.TRIPLE_A.func()
    },
    async onPay(state) {
      try {
        const res = await payOrderByTripleA({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'XAN_PAY',
    img: 'images/payTypes/xanpay.svg',
    name: 'XanPay',
    storeHint: `${baseSign} - XanPay.`,
    async onPay(state) {
      try {
        const res = await payOrderByXanPay({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },
  {
    type: 'BINANCE_USDT',
    img: 'images/payTypes/binances.svg',
    name: 'Binance',
    storeHint: `${baseSign} - BINANCE.`,
    async onPay(state) {
      try {
        const res = await payOrderByBinance({
          orderId: state.orderId,
          isInsufficient: state.needJumpOrder
        });
        if (res) {
          state.newTab.location = res;
        } else {
          state.newTab.close();
        }
        return res;
      } catch (error) {
        state.newTab.close();
      }
    }
  },

  ...AirwallexPayList(),

  ...CryptomusPayList()
];
